export default __webpack_public_path__ + "static/media/wegovy-check-flow-for-drop.1d595c6e.mp4";